import { emptyObject } from '@constants/empty';
import useFetch from '@hooks/useFetch';

const useRewardEvent = (
  options = {
    fallbackData: undefined
  },
  eventUID
) => {
  const key = `v1/common/fortune_draw/${eventUID}/prize_details/`;
  const { data, isValidating, ...rest } = useFetch(key, {
    fallbackData: options.fallbackData
  });
  const prizeEventDetails = data ?? emptyObject;

  return {
    key,
    isValidating,
    userWonPrizeDetails: prizeEventDetails.userPrizeDetails,
    prizeEventDetails,
    ...rest
  };
};

export default useRewardEvent;
